export const ALL_PANEL_POSITION_SETTINGS = ['auto', 'right', 'top'];
export const ALL_PANEL_POSITION_PROPERTIES = {
    auto: { label: 'Auto', isAvailableOnMobile: true },
    right: { label: 'Right', isAvailableOnMobile: true },
    top: { label: 'Top', isAvailableOnMobile: false }
};
